import { Controller } from '@hotwired/stimulus'

// Auto-generates a URL slug from a source field (e.g. title).
//
// Minimal usage:
//   <div data-controller="slug">
//     <input data-slug-target="source" data-action="input->slug#generate">
//     <input data-slug-target="output" data-action="input->slug#lock">
//   </div>
//
// Behavior:
//   - New record (output empty on connect): slug updates in real time as the
//     user types in source.
//   - Existing record (output has a value on connect): nothing is overwritten.
//   - If the user edits output manually, manual mode activates and generate()
//     stops updating for the rest of the session.
export default class extends Controller {
  static targets = ['source', 'output']

  connect() {
    // If a slug already exists (edit form), do not interfere.
    this._manual = this.outputTarget.value.length > 0
  }

  // Action for the source field (e.g. title).
  // Slugifies the value and writes it to output, unless manual mode is active.
  generate() {
    if (this._manual) return
    this.outputTarget.value = slugify(this.sourceTarget.value)
  }

  // Action for the output field (e.g. slug).
  // If the user types anything, activates manual mode and freezes generation.
  lock() {
    this._manual = this.outputTarget.value.length > 0
  }
}

// Converts free text to a URL-safe slug with Latin character support.
// Steps: NFD normalize → strip diacritics → lowercase → remove non-alnum → hyphens.
function slugify(text) {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
}
